import React from "react";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {useAppSelector} from "../../../../redux/hooks";

const AudioControlDialogInfo = () => {
    const audioControlData = useAppSelector(state => state.AudioControlListReducer.audioControlData)

    const nameBodyTemplate = (rowData: any) => {
        let name = rowData?.name;
        const truncateWithEllipses = (text: string, max: number) => {
            return text.substr(0, max - 1) + (text.length > max ? '...' : '');
        }
        if (name) {
            name = truncateWithEllipses(name, 156)
        }
        return (
            <React.Fragment>
                <div className="campaignName">
                    <p>{name}</p>
                </div>
            </React.Fragment>
        );
    };

    return (
        <DataTable className="user-dialog-info" value={audioControlData != null ? [audioControlData] : []}>
            <Column field="name" header="Назва" body={nameBodyTemplate} className="col-4"></Column>
            <Column field="description" header="Опис" body={rowData => rowData?.description || '- - -'} className="col-4"></Column>
            <Column field="isActive" header="Стан" body={rowData => rowData?.isActive ? 'Активна' : 'Не активна'} className="col-4"></Column>
        </DataTable>
    )
}

export default AudioControlDialogInfo;
